// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import router from '@app/router'; // default export is the router OBJECT
import AppThemeProvider from './app/providers/ThemeProvider';
import { NotificationProvider } from './app/notifications/NotificationProvider';
import { queryClient } from './app/queryClient';
// Supports weights 100-900
import "@fontsource/inter/latin.css";


import 'leaflet/dist/leaflet.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppThemeProvider>
      {/* Single global notification host. Every page uses useNotifications()
          from '@app/notifications/NotificationProvider' — no more mixing
          with the old SnackbarProvider or inline <Snackbar> patterns. The
          NotificationProvider also registers with notifyBridge so non-React
          callers (axios interceptor, boot-time errors) can fire toasts. */}
      <NotificationProvider>
        {/* Server state (reservations, groups, availability, ...) lives
            in TanStack Query. Client state (cart, flow stage, stay
            editor) stays in BookingFlowContext. See
            docs/frontend/server-state-migration.md for the split. */}
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          {import.meta.env.DEV ? (
            <ReactQueryDevtools
              initialIsOpen={false}
              buttonPosition="bottom-right"
            />
          ) : null}
        </QueryClientProvider>
      </NotificationProvider>
    </AppThemeProvider>
  </React.StrictMode>
);

